import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";

export const unauthorizedSubscriptionStatusesInTunnel = [
  subscriptionStatuses.subscribed,
  subscriptionStatuses.subscribedWaitingForPause,
  subscriptionStatuses.subscribedWaitingForPauseBlockedByCloset,
  subscriptionStatuses.subscribedWaitingForCancelation,
  subscriptionStatuses.subscribedWaitingForCancelationBlockedByCloset,
  subscriptionStatuses.pastDue,
  subscriptionStatuses.pastDueWaitingForPause,
  subscriptionStatuses.pastDueWaitingForCancelation,
  subscriptionStatuses.paused,
];
